import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource } from 'utility-ts-orm';
import { Resource } from '../builders/resource_builder';

export class ResourceSearchService {
  private MIN_SEARCH_TERM_LENGTH = 1;
  private MAX_SEARCH_RESULTS = 75;

  private _searchTerm: string = '';
  private _results: Resource[] = [];
  private _isSearching: boolean = false;

  constructor(private ngResourceDatastore: IDatasource<Resource>) {}

  private __cleanString(str: string) {
    return _4
      .trim(str)
      .toLowerCase()
      .replace(/[^\w\s]/g, '');
  }

  search(term: string): void {
    if (_4.isEmpty(term)) {
      this.reset();
      return;
    }

    term = this.__cleanString(term);
    this._searchTerm = term;
    this._isSearching = true;
    if (this._searchTerm.length >= this.MIN_SEARCH_TERM_LENGTH) {
      this._results = _4.filter(this.ngResourceDatastore.values(), (resource: Resource) => {
        const cleanedName = this.__cleanString(resource.name);
        return cleanedName.indexOf(term) > -1;
      });
    } else {
      this._results = [];
    }
  }

  reset(): void {
    this._searchTerm = '';
    this._isSearching = false;
  }

  isValidSearchTerm(): boolean {
    return !_4.isEmpty(this._searchTerm) && this._searchTerm.length >= this.MIN_SEARCH_TERM_LENGTH;
  }

  get allResults(): Resource[] {
    return this._results;
  }

  get isSearching(): boolean {
    return this._isSearching;
  }

  get searchTerm(): string {
    return this._searchTerm;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/services/resource_search_service.ts